import { PolicyEditState } from "models/policyPanel";
import Forms from "components/shared/Forms";
import { FormFieldType, ICustomFormField } from "models/properties";

export interface PolicyFormData {
  policyType: string;
  policyName: string;
  description: string;
}

interface PolicyPropertiesFormProps {
  editState: PolicyEditState;
  formValues: {
    policyType: string;
    policyName: string;
    description: string;
  };
  setFormValues: React.Dispatch<React.SetStateAction<{
    policyType: string;
    policyName: string;
    description: string;
  }>>;
}

// eslint-disable-next-line react/function-component-definition
const PolicyPropertiesForm = ({ editState, formValues, setFormValues }: PolicyPropertiesFormProps) => {
  const isNewPolicy = editState === PolicyEditState.NewPolicy;



  if (!isNewPolicy) {
    return (
      <div style={{ padding: "24px" }}>
        <p>Policy editing form will be implemented here.</p>
      </div>
    );
  }

  const policyTypeOptions = [
    { key: "Implicit Acceptance", text: "Implicit Acceptance" },
  ];

  const formFields: ICustomFormField[] = [
    {
      type: FormFieldType.select,
      propertyName: "policyType",
      propertyType: "properties",
      label: "Policy Type",
      required: true,
      value: formValues.policyType,
      defaultValue: formValues.policyType,
      disabled: true,
      options: policyTypeOptions,
      placeholder: "",
      dataAutomationId: "policyTypeField",
      width: "100%",
    },
    {
      type: FormFieldType.textField,
      propertyName: "policyName",
      propertyType: "properties",
      label: "Policy name",
      required: true,
      value: formValues.policyName,
      defaultValue: undefined,
      placeholder: "Enter policy name",
      dataAutomationId: "policyNameField",
      width: "100%",
    },
    {
      type: FormFieldType.textField,
      propertyName: "description",
      propertyType: "properties",
      label: "Description",
      required: false,
      value: formValues.description,
      defaultValue: undefined,
      placeholder: "Enter policy description",
      dataAutomationId: "policyDescriptionField",
      width: "100%",
    },
  ];

  const onPropertyChanged = (
    propertyType: string,
    propertyName: string,
    newValue: string | undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    defaultValue: string | undefined
  ) => {
    // Update local form state
    const updatedValues = {
      ...formValues,
      [propertyName]: newValue || ""
    };
    setFormValues(updatedValues);
  };

  const onPropertyBlur = (
    propertyType: string,
    propertyName: string,
    newValue: string | undefined
  ) => {
    // Handle form field blur events - could be used for validation
    // For now, just ensure the value is set correctly
    const updatedValues = {
      ...formValues,
      [propertyName]: newValue || ""
    };
    setFormValues(updatedValues);
  };

  return (
    <div style={{ padding: "0" }}>
      <Forms
        formFields={formFields}
        onPropertyChanged={onPropertyChanged}
        onPropertyBlur={onPropertyBlur}
      />
    </div>
  );
};

export default PolicyPropertiesForm;